import {
  genericMethodsApi,
  paymentMethodApiElavon,
  paymentMethodApiPayroc
} from '../utils/paymentMethodApi';

export const getMutationFn = (processor, method) => {
  if (!method) return null;

  const processorMethodsApiMap = {
    elavon: paymentMethodApiElavon,
    payroc: paymentMethodApiPayroc
  };

  const currentMethod =
    processorMethodsApiMap[processor]?.[method] ?? genericMethodsApi[method] ?? null;

  return currentMethod;
};
